import { useLocation } from 'react-router';
import { useContext } from 'react';
import { AppContext } from '@/contexts/app-context';
import { SupremeCardApplicationLabels } from './types';

type Customer = {
    customerType: string;
    governmentId: string;
    email: string;
    mobilePhone: string;
};

export type MapiError = {
    traceId: string;
    code: string;
    message: string;
    timestamp: string;
    statusCode: number;
};

export const useMapiApplication = ({ labels }: { labels: SupremeCardApplicationLabels }) => {
    const { url } = useContext(AppContext);
    const { pathname } = useLocation();

    function parseMapiErrors(error: MapiError) {
        const key = `mapiError${error.statusCode}Text` as keyof SupremeCardApplicationLabels;

        const errorMessage = labels?.[key] || labels.errorGenericContent;

        return {
            errorTitle: labels.errorGenericTitle,
            error: `${errorMessage}<br /><br /><hr/><br />Trace ID: ${error.traceId}`,
        };
    }

    const initMapiLoginFlow = async (card: string, customer: Customer) => {
        const currentUrl = new URL(pathname, url);

        const response = await fetch('/mapi-application', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                card,
                customer,
                failedApplicationUrl: `${currentUrl.toString()}?mapiConfirmationStatus=failed`,
                successApplicationUrl: `${currentUrl.toString()}?mapiConfirmationStatus=success`,
            }),
        });

        const data = await response.json();

        if (response.status === 201 && data?.taskRedirectionUrls?.customerUrl) {
            return {
                applicationId: data?.id || '',
                redirectUrl: data.taskRedirectionUrls.customerUrl,
            };
        }

        throw new Error(data?.message || 'There was an error', {
            cause: {
                ...data,
                statusCode: response.status,
            },
        });
    };

    return {
        parseMapiErrors,
        initMapiLoginFlow,
    };
};
